import {
    SPARE_PARTS_INTERNAL_GENERATED_PRESIGNED_URLS,
    SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR, SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_SAVED,
} from '../../constants/websocketCommands';
import {
    SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING,
    SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR
} from '../../actions/orders/actionSparePartsInternalTicketAttachments';
import {SPARE_PARTS_INTERNAL_TICKET_RESET} from '../../actions/orders/actionSparePartsInternalTicket';

export const sparePartsInternalTicketAttachment = (state = {
    correlationId: null,
    isTicketAttachmentUploading: false,
    attachmentsForUpload: [],
}, action) => {
    switch (action.type) {
        case SPARE_PARTS_INTERNAL_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case SPARE_PARTS_INTERNAL_GENERATED_PRESIGNED_URLS: {
            const {attachments} = action.payload;
            return Object.assign({}, state, {
                attachmentsForUpload: Array.isArray(attachments) ? attachments : [],
            });
        }
        case SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING: {
            return Object.assign({}, state, {isTicketAttachmentUploading: true});
        }
        //att done + error
        case SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR:
        case SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_UPLOADING_ERROR: {
            return Object.assign({}, state, {
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        case SPARE_PARTS_INTERNAL_TICKET_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketAttachmentUploading: false,
                attachmentsForUpload: [],
            });
        }
        default:
            return state;
    }
};
